var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "van-popup",
    {
      style: {
        width: "75%",
        maxHeight: "5.4rem",
        overflow: "hidden",
        borderRadius: "8px"
      },
      attrs: { closeable: "", position: "center" },
      on: { close: _vm.closeHandler },
      model: {
        value: _vm.showTips,
        callback: function($$v) {
          _vm.showTips = $$v
        },
        expression: "showTips"
      }
    },
    [
      _c("div", { staticClass: "tips-wrap" }, [
        _c("div", { staticClass: "tips" }, [_vm._v("资产说明")]),
        _c(
          "div",
          { staticClass: "content-wrap" },
          _vm._l(_vm.content, function(item) {
            return _c(
              "div",
              { staticClass: "content" },
              [
                _c("div", { staticClass: "title" }, [
                  _vm._v(_vm._s(item.title))
                ]),
                _vm._l(item.text, function(text) {
                  return _c("div", { staticClass: "text" }, [
                    _vm._v(_vm._s(text))
                  ])
                })
              ],
              2
            )
          }),
          0
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }